import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

/**
 * Angulars Standardstrategie entscheidet allein anhand der routeConfig, ob eine Komponente
 * wiederverwendet wird. Bei /issues/issue/A -> /issues/issue/B ist die routeConfig dasselbe Objekt,
 * die Instanz bleibt also stehen: ngOnDestroy und ngOnInit laufen nicht, die URL zeigt B, die
 * Ansicht weiter A.
 *
 * Diese Strategie zieht die Pfadparameter hinzu. Aendert sich einer, wird die Komponente zerstoert
 * und neu aufgebaut — damit greifen auch Aufraeumarbeiten aus ngOnDestroy (etwa die Abmeldung beim
 * RefetchCoordinator) und lokaler Zustand wie der Bearbeitungsmodus faellt zurueck.
 *
 * Query-Parameter bleiben bewusst aussen vor: die Listenseiten halten dort ihre Filter, und der
 * Sidebar-Deeplink (?type=…&show=…) baut seine Komponente ohnehin selbst neu auf
 * (sidebar.service.ts, createPersistentContent).
 */
export class ParamAwareRouteReuseStrategy extends BaseRouteReuseStrategy {

  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (!super.shouldReuseRoute(future, curr)) {
      return false;
    }

    const futureParams = future.params;
    const currentParams = curr.params;
    const keys = Object.keys(futureParams);

    return keys.length === Object.keys(currentParams).length
      && keys.every((key) => futureParams[key] === currentParams[key]);
  }
}
